<template>
  <div class="rule-dialog" slot="content">
    <div class="wrapper" v-html="rules"></div>
  </div>
</template>
<script>
  export default {
    name: 'Rule',
    props: {
      rules: String,
    },
  }
</script>
<style lang="scss">
  .rule-dialog {
    @include px2res(padding, 0, 25);
    .wrapper {
      position: relative;
      width: 100%;
      @include px2res(padding, 0, 25);
      @include px2res(height, 350);
      border-top: 0;
      overflow-y: auto;
      text-align: initial;
      line-height: 1.5;
      @include px2res(font-size, 28);
      * {
        line-height: 1.5;
        font-style: initial !important;
        color: #d1e9ed;
        font-family: inherit !important;
      }
      img {
        max-width: 100%;
        height: auto !important;
        max-width: 100%;
      }
      ol,
      ul {
        @include px2res(padding, 0, 40);
      }
      ol li {
        list-style: decimal;
      }
      ul li {
        list-style: initial;
      }
      table {
        width: 100% !important;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(123, 123, 123, 1);
        border-collapse: collapse;
        th,
        td {
          @include px2res(padding, 8, 0);
        }
        td img {
          vertical-align: middle;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rule/rule.vue